import React from "react";

import { Icon } from "@partials";
import { TabType, MOBILE, ALL } from "@constants";
import { getLocalization } from "@utilities";

import { IconsListProps, LocalizationProps } from "../../../types";

type FiltersMobileToggleProps = {
  type: TabType;
} & LocalizationProps &
  IconsListProps;

const FiltersMobileToggle: React.FC<FiltersMobileToggleProps> = ({
  iconsList,
  localization,
  type,
}) => {
  const { arrowDown } = iconsList;

  return (
    <div
      id={`filters-toggle-container-${MOBILE}-${type}-${ALL}`}
      className="select-none px-8 pb-12"
    >
      <button type="button" id={`filters-toggle-button-${MOBILE}-${type}-${ALL}`}>
        <div>
          {getLocalization(localization, "Branches_Filters_RefineSearch")}
          <Icon
            name={arrowDown.name}
            viewBox={arrowDown.viewbox}
            alt={arrowDown.alt}
            svg={arrowDown.svg}
            className="inline h-8 w-8 fill-red-corporate"
            id={`filters-toggle-button-icon-${MOBILE}-${type}-${ALL}`}
          />
        </div>
      </button>
    </div>
  );
};

export default FiltersMobileToggle;
